import { render, staticRenderFns } from "./shutdown.vue?vue&type=template&id=580d515c"
import script from "./shutdown.vue?vue&type=script&lang=js"
export * from "./shutdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports